import { Box, Button, CircularProgress } from '@mui/material';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { downloadPECRExcelList } from '../../queries/downloadQueries';
import { errorNotification } from '../../reducers/handle-api-status/slice';
import { buttonCircularProgress } from '../../styles';
function DownloadList(props) {
  const [isDownloading, setIsDownloading] = useState(false);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { selectedFilterOption, searchString } = props;
  const onDownloadExcel = async () => {
    try {
      setIsDownloading(true);
      await downloadPECRExcelList({
        search: searchString,
        sort: selectedFilterOption.SortBy ? selectedFilterOption.SortBy : 'ID',
        ascdesc: selectedFilterOption.OrderBy
          ? selectedFilterOption.OrderBy
          : 'desc',
        filterStatus: selectedFilterOption.StatusFilter,
        filterSites: selectedFilterOption.SitesFilter,
        filterProductFamily: selectedFilterOption.ProductFilter,
      });
      setIsDownloading(false);
    } catch (error) {
      setIsDownloading(false);
      dispatch(
        errorNotification({
          hasErrorOccured: true,
          message: t('error_message'),
        })
      );
    }
  };

  return (
    <Box sx={{ position: 'relative' }}>
      <Button
        variant="contained"
        onClick={onDownloadExcel}
        sx={{
          textTransform: 'none',
          fontSize: '16px',
          backgroundColor: 'rgba(255, 255, 255, 0.2)',
          '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.3)',
          },
          backdropFilter: 'blur(10px)',
          border: '1px solid rgba(255, 255, 255, 0.3)',
        }}
        disabled={isDownloading}
      >
        {t('Download_Excel')}
      </Button>
      {isDownloading && (
        <CircularProgress size={28} sx={buttonCircularProgress} />
      )}
    </Box>
  );
}

DownloadList.propTypes = {
  selectedFilterOption: PropTypes.object.isRequired,
  searchString: PropTypes.string.isRequired,
};

export default DownloadList;
